<template>
  <div class="card card--bordered card--vertical">
    <div class="card__wrapper">
      <div class="card__media" v-show="offer.img_url">
        <div class="media media--product">
          <img class="media__src" :src="offer.img_url" />
        </div>
      </div> 
      <div class="card__content">
        <div class="content content--spaced">
          <h1 class="content__heading mod--size--28 mod--weight--700">
            {{ offer.offer_headline }}
          </h1>
          <h2 class="content__heading mod--size--18">
            {{ offer.offer_subheadline }}
          </h2>
          <template v-for="(bullet, index) in offer.offer_bulletpoint">
            <span
              class="content__separator" v-show="index == 3"
              :key="'separatoe' + index"
            ></span>
            <div
              class="content__point mod--weight--700 mod mod--align--left"
              :key="'bullet' + index"
            >
              <span class="content__point__indicator">
                <span class="content__icon mod mod--theme--primary icon-tick-inside-circle"></span>
              </span>
              <span
                class="content__point__label mod"
                :class="{
                  'mod--weight--300': index > 2,
                  'mod--weight--600': index <= 2
                }"
              >
                {{ bullet }}
              </span>
            </div>
          </template>
        </div>
      </div>
      <div class="card__footer">
        <div class="content">
          <span class="content__text mod mod--size--22 mod--weight--600">
            Bestellung
          </span>
          <span
            class="content__text mod mod--theme--secondary mod--weight--600"
          >
            Zusammenfassung
          </span>
          <span
            class="content__text mod mod--theme--secondary mod--weight--100"
          >
            <template v-for="(row, index) in subtotalRows">
              <span
                :key="'subtotal-row' + index"
                v-show="row && (row.value || row.showEmpty)"
              >
                {{ row && row.label }}
                <span
                  class="mod mod--float--right"
                  v-show="row && row.value && !row.hideValue"
                >
                  {{ row && row.value | currency }}
                </span>
                <br />
              </span>
            </template>
          </span>
          <div class="content__line"></div>
          <template v-for="(row, index) in totalRows">
            <span
              class="content__text mod mod--weight--600"
              :key="'total-row' + index"
              v-show="row && (row.value || row.showEmpty)"
            >
              {{ row.label }}
              <span
                class="mod mod--float--right mod mod--size--20 mod--theme--primary mod--weight--700"
              >
                {{ row.value | currency }}
              </span>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fields", "summary", "offer"],
  name: "checkout-summary",
  computed: {
    totalRows: function() {
      return this.summary && this.summary.total
        ? this.summary.total.map(row => {
            let subtotals = row.subtotal
              ? row.subtotal
                  .map(index => this.subtotalRows[index])
                  .filter(item => item)
                  .filter(item => !isNaN(item.value) && item.value !== "")
              : [];

            return {
              label: row.label,
              value:
                subtotals.length > 0
                  ? subtotals.reduce(
                      (sum, item) => sum + (parseInt(item.value) || 0),
                      parseInt(row.value) || 0
                    )
                  : row.value,
              showEmpty: row.showEmpty
            };
          })
        : [];
    },
    subtotalRows: function() {
      return this.summary && this.summary.subtotal
        ? this.summary.subtotal.map(row => {
            if (!row.fields && !row.field) {
              return {
                label: row.label,
                value: row.value,
                showEmpty: row.showEmpty
              };
            }

            if (!row.fields && row.field) {
              row.fields = [row.field];
            }

            let fields =
              row.fields && row.fields.length > 0
                ? row.fields
                    .map(field => {
                      return field.reduce(
                        (obj, key) => {
                          return obj.fields.find(field =>
                            obj.type === "conditional"
                              ? obj.value === field.name && field.name === key
                              : field.name === key
                          );
                        },
                        { fields: this.fields }
                      );
                    })
                    .filter(field => field)
                : null;

            if (!fields) return null;

            let fieldsValue = fields.map(field => field.value).join(".");

            var value =
              row.map && row.map.value
                ? row.map.value[fieldsValue]
                : fieldsValue;
            var label =
              row.map && row.map.label ? row.map.label[fieldsValue] : row.label;

            if (!value) return null;

            return {
              label: label,
              value: value,
              hideValue: row.hideValue,
              showEmpty: row.showEmpty
            };
          })
        : [];
    }
  }
};
</script>
